import { render, staticRenderFns } from "./WijkBeknopt.vue?vue&type=template&id=1ed37ff2&"
import script from "./WijkBeknopt.vue?vue&type=script&lang=js&"
export * from "./WijkBeknopt.vue?vue&type=script&lang=js&"
import style0 from "./WijkBeknopt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WijkBeknopt.vue"
export default component.exports